const SHOW_CREATE_SCRATCH_APP_KEY = 'designstudio.showCreateScratchAppMenu';

let memoryPreference: boolean | undefined;

type LocalStorageLike = {
  readonly getItem: (key: string) => string | null;
  readonly setItem: (key: string, value: string) => void;
  readonly removeItem: (key: string) => void;
};

function readStorage(): LocalStorageLike | undefined {
  if (typeof globalThis === 'undefined') {
    return undefined;
  }
  try {
    const storage = (globalThis as { readonly localStorage?: LocalStorageLike }).localStorage;
    if (storage === undefined) {
      return undefined;
    }
    // Probe — some test runners expose a non-functional localStorage stub.
    const probeKey = `${SHOW_CREATE_SCRATCH_APP_KEY}.probe`;
    storage.setItem(probeKey, '1');
    storage.removeItem(probeKey);
    return storage;
  } catch {
    return undefined;
  }
}

/** Soft-hide for the experimental “Nouvelle app” tile (default: hidden). */
export function readShowCreateScratchAppMenu(): boolean {
  const storage = readStorage();
  if (storage !== undefined) {
    return storage.getItem(SHOW_CREATE_SCRATCH_APP_KEY) === '1';
  }
  return memoryPreference === true;
}

export function writeShowCreateScratchAppMenu(enabled: boolean): void {
  const storage = readStorage();
  if (storage !== undefined) {
    if (enabled) {
      storage.setItem(SHOW_CREATE_SCRATCH_APP_KEY, '1');
    } else {
      storage.removeItem(SHOW_CREATE_SCRATCH_APP_KEY);
    }
  }
  memoryPreference = enabled ? true : undefined;
}
